import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SupplierAuthService } from '../services/supplier-auth.service';

export const supplierAuthGuard: CanActivateFn = (route, state) => {
  const auth = inject(SupplierAuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    auth.recordActivity();
    return true;
  }

  if (route.queryParamMap.get('key')) {
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

export const supplierLoginGuard: CanActivateFn = () => {
  const auth = inject(SupplierAuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  auth.recordActivity();
  return router.parseUrl('/');
};
